import React from "react";

import { CronJobType } from "../../../../../../../../../util/enums";
import { useActionReportMaintenance } from "../../../hooks/useAction";
import { useReportState } from "../../../hooks/useReportState";
import { BaseReportGrid } from "../../BaseReportGrid";
import { useShipmentColumns } from "./hooks/useShipmentsColumns";
import { useShipmentsFilters } from "./hooks/useShipmentsFilters";

export const ShipmentsReport = () => {
  const { getAllShipments, getCrossDock } = useActionReportMaintenance();
  const { type, ...reportStateProps } = useReportState();

  const { getShipmentReportColumns, getShipmentReportRequiredFilters } = useShipmentColumns();
  const { getShipmentReportDateOptions, getShipmentReportFilters, getShipmentReportPeriodOptions } =
    useShipmentsFilters();

  const shipmentReportInclude = [
    {
      association: "milestones",
      include: [{ association: "milestone" }],
    },
  ];

  return (
    <BaseReportGrid
      getAllData={type === CronJobType.REPORT ? getAllShipments : getCrossDock}
      columns={getShipmentReportColumns(type)}
      filterCategories={getShipmentReportFilters(type)}
      filterByOptions={getShipmentReportFilters(type)}
      dateOptions={getShipmentReportDateOptions(type)}
      periodOptions={getShipmentReportPeriodOptions(type)}
      requiredFilters={getShipmentReportRequiredFilters(type)}
      reportInclude={type === CronJobType.REPORT ? shipmentReportInclude : undefined}
      {...reportStateProps}
    />
  );
};
